let n = 0
export function usePageOverlay(
  onClick: (e: Event) => void,
  onKeyup: (e: KeyboardEvent) => void,
) {
  return {
    show() {
      n += 1
      document.documentElement.classList.add('PageOverlay--is-visible')
      document.body.addEventListener('click', onClick)
      document.addEventListener('keyup', onKeyup)
    },
    hide() {
      n = Math.max(n - 1, 0)
      document.body.removeEventListener('click', onClick)
      document.removeEventListener('keyup', onKeyup)
      // hide the element if it's the last modal
      if (n < 1) {
        document.documentElement.classList.remove('PageOverlay--is-visible')
      }
    },
  }
}
